export const outlierSearchTerms = [
  'bucomaxilo',
  'cirur den',
  'cirur dent',
  'cirurgiao den',
  'cirurgiao dent',
  'cirurgiao dentista',
  'clareamento',
  'cons dent',
  'cons odo',
  'cons odont',
  'consulta den',
  'consulta dent',
  'consulta dentista',
  'consulta odo',
  'consulta odon',
  'consulta odont',
  'consulta odonto',
  'consulta odontologia',
  'consulta odontologica',
  'dent',
  'dentid',
  'dentis',
  'dentist',
  'dentista',
  'dentistas',
  'dentisti',
  'dentistica',
  'dentística',
  'endod',
  'endodo',
  'endodont',
  'endodontia',
  'extr de de',
  'extr den',
  'extr dent',
  'extra de den',
  'extracao de de',
  'extracao de dente',
  'extracao den',
  'extracao dent',
  'impl den',
  'implante den',
  'implante dent',
  'implante dentario',
  'lim den',
  'lim dent',
  'limpeza den',
  'limpeza dent',
  'limpeza dental',
  'limpeza dente',
  'odon',
  'odon pediatra',
  'odont',
  'odont pediatra',
  'odonto',
  'odonto pediatra',
  'odontologi',
  'odontologia',
  'odontologica',
  'odontop',
  'odontoped',
  'odontopedagogia',
  'odontopedi',
  'odontopediat',
  'odontopediatr',
  'odontopediatra',
  'odontopediatri',
  'odontopediatria',
  'odontopedista',
  'period',
  'periodo',
  'periodon',
  'periodont',
  'periodontia',
  'raio x den',
  'raio x dent',
  'raio x dente',
  'sapato',
  'tomo dentaria',
  'tomografia den',
  'tomografia dentaria',
  'tomografia dente',
];
